module.exports = __webpack_public_path__ + "img/11.1e60917a.svg";